import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';

/** Fila de `GET /ova/api/traslados/tipos-solicitud` (`TRL_CAT_TIPO_SOLICITUD`). */
export interface TipoSolicitudDTO {
  idTipoSolicitud: number;
  descripcion?: string;
  codigo?: string;
  estado?: number | string;
}

@Injectable({
  providedIn: 'root',
})
export class TiposSolicitudService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.TIPOS_SOLICITUD}`;

  constructor(private http: HttpClient) {}

  getTiposSolicitud(): Observable<TipoSolicitudDTO[]> {
    return this.http.get<TipoSolicitudDTO[]>(this.apiUrl);
  }
}
